// i18n area 'apps' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/apps.da-DK.meta.json.
import type { enUS } from './apps'

export const daDK: typeof enUS = {
  apps: {
    title: 'Apps',
    create: 'Opret app',
    createTitle: 'Opret app',
    editTitle: 'Rediger app',
    name: 'Navn',
    nameHint: 'DNS-1123, unikt i scopet — uforanderligt efter oprettelsen.',
    node: 'Node',
    nodeHint: 'Medlemsnoden, der betjener den — eksplicit placement (scheduleren kommer senere).',
    image: 'Image',
    editImageHint: 'En ny reference genopløses gennem kartoteket — pin-/rollback-grebet.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digestet flytter sig kun på kommando.',
    policyTrackingHint: 'Automatisk rolling, når et refresh flytter branchen.',
    archMovePolicy: 'Cross-arch-flytning',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Hvad der sker, hvis appen flyttes til en node med en anden arkitektur: refuse afviser flytningen, reresolve genopløser lockfilen fra branchen på den nye arch — indholdet ændrer sig, og svaret nævner digest-ændringen.',
    network: 'Netværk',
    networkHint: 'Untagged L3-tilkobling: et logisk fabric-netværk (anbefalet — gateway/DNS fra dets eneste kilde), et overlay eller en nøgen host-bridge (frarådes).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host-bridge:',
    ipAssignment: 'IP-tildeling',
    ipStatic: 'Statisk',
    ipAuto: 'Automatisk (IPAM)',
    ipAssignmentHint_static: 'Adressen giver du selv, nu.',
    ipAssignmentHint_auto: 'IPAM vælger en ledig adresse fra netværkets TVirt-reserverede ranges.',
    bridgeDiscouraged: 'Nøgen host-bridge — FRARÅDES: TVirt ved intet om dens adressering, så gateway og DNS skal gives i hånden. Den anbefalede vej er et logisk fabric-netværk.',
    ip: 'IP',
    ipHint: 'Statisk IPv4 inden for tilkoblingens subnet.',
    ipCidrHint: 'I CIDR-form på en nøgen bridge (fx 192.168.1.10/24) — der er intet at aflede præfikset fra.',
    gateway: 'Gateway',
    gatewayManualHint: 'Manuel — en nøgen bridge afleder intet.',
    dnsServers: 'DNS-servere',
    dnsManualHint: 'Manuelle, kommaseparerede — mindst én.',
    rootKind: 'Root',
    rootEphemeral: 'efemer',
    rootPersistent: 'persistent',
    rootEphemeralHint: 'Genskabes fra imaget ved hver genskabelse; bor på clusterets efemere storage.',
    rootEphemeralHintNamed: 'Genskabes fra imaget ved hver genskabelse; bor på clusterets efemere storage ({name}).',
    rootPersistentHint: 'Overlever genstarter; bor på den storage, du vælger.',
    rootStorage: 'Root-storage',
    editRootStorageHint: 'Rooten genrenderes på den nye pool — de eksisterende data flytter IKKE sig selv.',
    volumes: 'Volumener',
    volumeAdd: 'Tilføj volumen',
    volumeName: 'Navn',
    volumeMountPath: 'Mount-sti',
    volumeKind: 'Type',
    volumeStorage: 'Storage',
    devices: 'Enheder',
    deviceClassHint: 'Man beder om en KLASSE (et gpu-device- eller usb-device-tag), aldrig en bestemt enhed: den angivne node skal have en markeret til Apps. Flere Apps kan bruge samme enhed — en container deler den, den tager den ikke fra værten.',
    deviceSlot: 'Slot',
    deviceTag: 'Tag',
    deviceValue: 'Klasse',
    deviceUnresolved: 'intet bliver løst lige nu',
    noDeviceTags: 'Endnu intet tag af typen gpu-device eller usb-device: opret et, og tildel det til de enheder der er markeret til Apps.',
    env: 'Miljø',
    envHint: 'Én NØGLE=værdi pr. linje.',
    secretEnvTitle: 'Hemmelige variabler',
    secretEnvNotice: "En hemmelig værdi kommer aldrig tilbage fra API'et: ingen læser den igen, ikke engang den, der skrev den. I checkpointet rejser den forseglet med masterpassen, så en gendannelse uden masterpassen beder om at få den skrevet igen.",
    secretEnvPromote: 'Gør en af variablerne skrevet ovenfor hemmelig:',
    secretEnvAdd: 'Tilføj hemmelig variabel',
    secretEnvName: 'Navn',
    secretEnvValue: 'Værdi',
    secretEnvKept: 'bevaret — lad feltet stå tomt for at lade den være uændret',
    secretEnvWithdrawWarning: 'For at holde op med at behandle en variabel, der allerede er hemmelig, som hemmelig skal du skrive en ny værdi til den: alene at fjerne markeringen ville være en måde at LÆSE det, der aldrig forlader storet. At fjerne variablen sletter den derimod.',
    secretEnvChip: 'hemmelig',
    startNow: 'Start med det samme (ellers fødes appen stoppet)',
    deletePersistentIntro: 'Denne app har persistente data — vælg, hvad der skal ske med dem:',
    deleteKeepData: 'Behold dataene (mapperne bliver på deres storage, forældreløse)',
    deletePurgeData: 'Slet også dataene',
    phase: 'Fase',
    phase_running: 'Kører',
    phase_stopped: 'Stoppet',
    phase_error: 'Fejl',
    phase_unknown: 'Ukendt',
    desiredState: 'Ønsket',
    wantedRunning: 'kørende',
    wantedStopped: 'stoppet',
    start: 'Start',
    stop: 'Stop',
    restart: 'Genstart',
    refreshImage: 'Opdater image (adopter det nye @current)',
    logs: 'Log',
    logsTitle: 'Log',
    logsEmpty: 'Intet output opfanget.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Appen kører ikke — en shell har brug for en levende container. Dens logs kan læses i enhver tilstand.',
    shellConnect: 'Forbind',
    shellDisconnect: 'Afbryd',
    shellExited: 'Sessionen sluttede med exit-kode {code}.',
    shellEndedWithoutStatus: 'Sessionen sluttede uden en exit-status: {reason}',
    shellRevoked: 'Sessionens ticket er ikke længere gyldig — den udløb, eller det login, der åbnede den, blev tilbagekaldt.',
    shellHint: 'Klik i det sorte felt og skriv: tasterne går til containeren. Ctrl+C og piletasterne virker; exit lukker shellen.',
    shellStatus: {
      connecting: 'Forbinder…',
      connected: 'Forbundet',
      ended: 'Afsluttet'
    },
    deleteRunningError: '{name} er ønsket kørende — stop den først.',
    tabs: {
      general: 'Generelt',
      image: 'Image',
      network: 'Netværk',
      storage: 'Storage',
      devices: 'Enheder',
      observed: 'Observeret'
    },
    attachment: 'Tilkobling',
    runningDigest: 'Kørende digest',
    lastError: 'Seneste fejl',
    reportObservedAt: 'Workerens seneste rapport',
    desiredStateLock: 'Styres af handlingerne Start/Stop — aldrig en direkte redigering.',
    ipEditDisabledHint: 'Kan kun redigeres med statisk tildeling.',
    derivedFromNetworkHint: 'Afledt af netværkets eneste kilde — manuel kun på nøgen bridge med statisk IP.',
    ephemeralUnset: 'ikke konfigureret',
    ephemeralMissing: 'Apps efemere storage er ikke konfigureret — at oprette en app med efemere dele (root eller volumener) afvises, indtil du sætter den.',
    ephemeralCurrent: 'Apps efemere storage: {name}',
    ephemeralMissingCreate: 'Denne app har efemere dele, men Apps efemere storage er ikke sat — oprettelsen vil blive afvist. Sæt den først fra banneret på App-siden.',
    setEphemeral: 'Sæt efemer storage',
    changeEphemeral: 'Skift efemer storage',
    setEphemeralTitle: 'Sæt Apps efemere storage',
    changeEphemeralTitle: 'Skift Apps efemere storage',
    ephemeralStorageHint: 'Cluster-DEFAULT: den dir-lignende pool, hvor hver apps efemere roots og volumener bor, medmindre appen erklærer et override. Et skift er ikke hot og genstarter intet: det gælder fra hver apps næste start — de efemere data flyttes ikke.',
    ephemeralPool: 'Storage-pool',
    ephemeralOverride: 'Efemer storage (override pr. app)',
    ephemeralOverrideInherit: 'Arver clusterets default',
    ephemeralOverrideInheritNamed: 'Arver clusterets default ({name})',
    ephemeralOverrideHint: 'Pool pr. app til efemere roots og volumener — lad stå tomt for at arve clusterets default. At ændre den er ikke hot og genstarter intet: det gælder fra næste start (efemere data genfødt tomme på den nye pool) og kræver tilladelsen app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Alle branches',
    imageBranchHint: 'Begrænser images til dem, denne branch navngiver; uden branch ses alle repositoryets images.',
    imageDigestHint: 'Indholdet: vælges fra digest-tabellen, som bærer dets oprindelse og dets arkitektur. Den samme branch tilbyder ét pr. arkitektur, og de kan ikke byttes ud med hinanden.',
    imageLockfile: 'Opløst reference',
    imageNoImages: 'Intet image i cachen for dette repository — hent et fra OCI-images.',
    imageHeadNotCached: 'ikke i cachen — hentes ved start',
    imageNoRegistries: 'Intet repository registreret: registrér et for at kunne vælge et image.',
    imageChosenHint: 'Imaget vælges i kaskaden i redigeringsdialogen: referencen skrives aldrig i hånden.',
    registerRepositoryHint: 'Registrering henter ingenting: den gør et repository observerbart, så imaget kan vælges uden at forlade denne dialog.',
    registerRepositoryBranchHint: 'Valgfrit: den første branch, der skal observeres (f.eks. latest).',
    registerRepositoryElsewhere: 'Det søgte repository er ikke registreret: registreringen sker i afsnittet OCI-images, af en med tilladelsen.'
  },
  cts: {
    createAction: 'Opret CT',
    createTitle: 'Opret en container fra en template',
    createError: 'Containeren blev ikke oprettet',
    template: 'CT-template',
    noTemplates: 'Ingen CT-templates — importer en fra CT-templates',
    resources: 'Ressourcer',
    node: 'Node',
    phase: {
      defined: 'Aldrig tændt',
      materializing: 'Materialiseres',
      ready: 'Klar',
      starting: 'Starter',
      running: 'Kører',
      stopping: 'Stopper',
      stopped: 'Stoppet',
      deleting: 'Under sletning',
      error: 'I fejltilstand'
    },
    actions: {
      start: 'Start',
      stop: 'Stop',
      restart: 'Genstart',
      markTemplate: 'Forfrem til CT-template',
      error: 'Handlingen blev afvist'
    },
    markTemplate: {
      confirmTitle: "Forfremme '{name}' til CT-template?",
      confirmBody: 'Containeren forlader denne liste og går over til CT-templates, straks klar til at frembringe nye CT. Dens metadata kan stadig redigeres, og du kan gøre den til CT igen når som helst.',
      confirm: 'Forfrem',
      moved: "'{name}' er nu en CT-template — du finder den under CT-templates."
    },
    stopCause: {
      api: 'Stoppet af TVirt',
      'ct-exit': 'Containeren afsluttede af sig selv',
      'host-reboot': 'Døde med nodens genstart',
      'start-failed': 'Starten fejlede — taskens fejl siger, hvad der mangler, og hvordan det rettes'
    },

    console: 'Konsol',
    consoleUnavailable: 'Containeren kører ikke — en konsol kræver en levende container. Dens log kan derimod læses i enhver tilstand.',
    consoleNoTemplate: 'En template kører aldrig og har derfor ingen konsol: opret en CT ud fra den, og åbn dens konsol.',
    consoleConnect: 'Forbind',
    consoleDisconnect: 'Frakobl',
    consoleReconnect: 'Forbind igen',
    consoleTakenBy: 'En anden operatør har taget denne konsol ({user}). Én konsol pr. container: forbinder du igen, tager du den tilbage.',
    consoleHint: 'Klik på det sorte felt og skriv: tasterne når frem til containeren. Ctrl+C og piletasterne virker.',
    consoleEndpointDown: 'Konsollens adgangspunkt kan ikke åbnes på den node, der betjener containeren: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Containeren kører ikke — en shell har brug for en levende container. Dens logs kan læses i enhver tilstand.',
    shellNoTemplate: 'En template kører aldrig, så den har ingen shell: opret en CT ud fra den og åbn dens.',
    shellConnect: 'Forbind',
    shellDisconnect: 'Afbryd',
    shellExited: 'Sessionen sluttede med exit-kode {code}.',
    shellEndedWithoutStatus: 'Sessionen sluttede uden en exit-status: {reason}',
    shellRevoked: 'Sessionens ticket er ikke længere gyldig — den udløb, eller det login, der åbnede den, blev tilbagekaldt.',
    shellHint: 'Klik i det sorte felt og skriv: tasterne går til containeren. Ctrl+C og piletasterne virker; exit lukker shellen.',
    shellStatus: {
      connecting: 'Forbinder…',
      connected: 'Forbundet',
      ended: 'Afsluttet'
    },
    rootPassword: 'Root-adgangskode',
    rootPasswordHint: 'Skrives én gang ind i det kopierede rootfs (som hash, vises aldrig igen). Distributionernes images har ingen root-adgangskode: uden en er shellen den eneste vej ind.',
    sshKeys: 'Offentlige SSH-nøgler for root',
    sshKeysHint: 'Én offentlig OpenSSH-nøgle pr. linje, i root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Forbinder…',
      connected: 'Forbundet',
      reconnecting: 'Forbinder igen…'
    },
    logs: 'Log',
    logsTitle: 'Log',
    logsEmpty: 'Intet output opfanget.',
    logsSource: 'Hvilken log',
    logsSourceConsole: 'Containerens init-konsol — hvorfor tjenesten indeni ikke startede',
    logsSourceSupervisor: 'liblxc-supervisoren — hvorfor containeren aldrig nåede at køre',
    logsNeverStarted: 'Den er aldrig blevet startet, så der er endnu intet registreret — start den, og loggen er der, også selv om starten fejler.',
    logsNoTemplate: 'En template kører aldrig og har derfor aldrig registreret noget.',
    logsError: 'Loggen blev ikke opfanget',

    tabs: {
      general: 'Generelt',
      hardware: 'Hardware',
      network: 'Netværk',
      provenance: 'Oprindelse'
    },
    templateFlag: 'CT-template',
    templateLock: 'Ændres kun med handlingerne Forfrem / Gør til CT igen — aldrig en direkte redigering.',
    sourceLock: 'Oprindelse, registreret ved fødslen — omskrives aldrig; en død kilde efterlader referencen nøgen.',
    storageLock: 'Fastlagt ved oprettelsen — flytning af rootfs er et fremtidigt round.',
    startedAt: 'Startet',
    lastStop: 'Seneste stop',
    editNicsTitle: 'Rediger netværk',
    nicDisconnected: 'frakoblet'
  },
  ctTemplates: {
    title: 'CT-templates',
    importAction: 'Importer fra katalog',
    importTitle: 'Importer CT-template fra kataloget',
    importSubmit: 'Importer',
    importError: 'Importen blev afvist',
    importHint: 'Materialiseringen kopierer rootfs til den valgte storage — katalogfilen forbliver intakt. For at tilføje nye filer skal de først uploades til et katalog.',
    sourceFile: 'CT-template-fil',
    sourceFileHint: 'ct-rootfs-filerne i det valgte katalog, kun de klare',
    noFiles: 'Ingen klar ct-rootfs-fil i dette katalog — upload en fra katalogets side',
    source: 'Kildefil',
    rootfsStorage: 'Rootfs-storage',
    rootfsStorageHint: "Hvor det udpakkede rootfs-træ bor — en storage med filsystem og nok ledig plads til den udpakkede størrelse plus ca. 1 GiB i margin (ellers mislykkes importen).",
    resources: 'Ressourcer',
    cores: 'vCPU',
    memoryMiB: 'Hukommelse (MiB)',
    cpuLimit: 'CPU-grænse',
    cpuLimitHint: 'Ækvivalenter i host-kerner (fx 1.5); tom = uden loft',
    cpuUncapped: 'uden loft',
    cpuWeight: 'CPU-vægt',
    hostname: 'Hostname',
    hostnameHint: "Tomt = CT'ens navn",
    nameservers: 'DNS-nameservere',
    dnsHint: 'Kommaseparerede; tomt = arver hostens',
    searchDomains: 'DNS-søgedomæner',
    dnsInherited: 'Arvet fra hosten',
    networks: 'Netværk',
    nicSlot: 'NIC-slot',
    phase: {
      materializing: 'Materialiseres',
      ready: 'Klar',
      deleting: 'Under sletning',
      error: 'Fejl'
    },
    exportAction: 'Eksporter til kataloget',
    exportTitle: 'Eksporter til kataloget',
    exportSubmit: 'Eksporter',
    exportError: 'Eksporten blev afvist',
    exportHint: 'Pakker det materialiserede rootfs ind i en NY ct-rootfs-fil i det valgte katalog — templaten forbliver intakt.',
    exportName: 'Filnavn',
    exportNameHint: 'Tomt = <template>-export-<n>',
    markCt: {
      action: 'Gør til CT igen',
      confirmTitle: "Gøre '{name}' til CT igen?",
      confirmBody: 'Templaten forlader denne liste og vender tilbage til CT-listen, igen startbar. Indtil du forfremmer den igen, kan der ikke oprettes CT fra den.',
      confirm: 'Gør til CT igen',
      moved: "'{name}' er igen en CT — du finder den i CT-listen."
    }
  },
  oci: {
    registriesTitle: 'OCI-registries',
    imagesTitle: 'OCI-images',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generisk',
    providerImmutableHint: 'Provideren er uforanderlig efter oprettelsen — en anden provider er et nyt registry.',
    url: 'URL',
    urlHintPreset: 'Forudfyldt af provideren — overskriv kun for mirrors.',
    urlHintRequired: 'Obligatorisk for generiske registries: https://-basis-URL.',
    urlHintEcr: 'Obligatorisk: ECR-endpoints er pr. konto/pr. region — der findes intet preset.',
    credential: 'Credential',
    credentialNone: 'Anonym adgang',
    credentialHint: 'En keystore-post med brugernavn og adgangskode; workerne opløser den ved brug — aldrig auth-filer pr. node.',
    nameHint: 'Host-lignende navn (docker.io, registry.intra); unikt pr. scope, uforanderligt',
    addRegistry: 'Tilføj registry',
    addRegistryTitle: 'Tilføj OCI-registry',
    verify: 'Verificer',
    verifyState: 'Verifikation',
    verified: 'Verificeret',
    verifyFailed: 'Fejlet',
    neverVerified: 'Aldrig verificeret',
    registryInUseError: "'{name}' har stadig registrerede repositories — slet dem først.",
    repositories: 'Repositories',
    repositoriesHint: 'At registrere observerer branches (OCI-tags) — der downloades intet. Refresh opløser hver observeret branch og vedligeholder refloggen.',
    noRepositories: 'Intet repository registreret på dette registry.',
    registerRepository: 'Registrer repository',
    repoPath: 'Sti',
    repoPathHint: "Repositoryets sti på registryet, fx 'example' eller 'library/nginx'",
    branches: 'Branches',
    branchesHint: 'Observerede branches (OCI-tags), kommaseparerede — fx 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Opløst NU: pullet downloader det digest, branchen peger på i dag.',
    refresh: 'Opdater',
    deleteRepository: 'Slet repository',
    reflogCount: '{n} tidligere',
    noResolutions: 'Aldrig opdateret — ingen opløsning observeret.',
    refreshFailed: 'Seneste opdatering fejlede ({when})',
    loadError: 'Kunne ikke indlæse repositories.',
    reference: 'Reference',
    digest: 'Digest',
    digestHint: 'sha256:… — det præcise image, uden branch (detached)',
    size: 'Størrelse',
    nodes: 'Noder',
    detached: 'detached',
    detachedHint: 'Downloadet efter digest, uden branch — drift-kontrollen gælder ikke.',
    pulledAt: 'Downloadet',
    pull: 'Pull',
    pullTitle: 'Pull image',
    pullHint: 'Pre-warming, aldrig en forudsætning: et pull pr. branch opløser NU og downloader DET digest; et pull pr. digest er detached.',
    pullError: 'Pullet blev afvist',
    pullMode: 'Pull efter',
    pullModeBranch: 'Branch (opløs nu)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Den ærlige default: som apt install — kørt igen senere kan det give et andet image.',
    pullModeDigestHint: 'Præcist digest — reproducerbarhed og rollback; giver afkald på drift-kontrollen.',
    importFromRegistry: 'Importer fra registry',
    importFromCatalog: 'Importer fra katalog',
    importCatalogTitle: 'Importer OCI-image fra katalog',
    importCatalogHint: 'Den air-gappede vej: et klart oci-image-arkiv (tar/tar.gz — docker-archive eller oci-archive) materialiseres i image-storen med referencen catalog/<katalog>/<fil>@<digest>; apps konsumerer det som ethvert andet image. Arkiverne uploades til katalogerne — denne sektion importerer og intet andet.',
    importCatalogFile: 'Arkiv',
    importCatalogFileHint: 'De klare oci-image-filer i det valgte katalog.',
    importCatalogNoFiles: 'Intet klart oci-image-arkiv i dette katalog — upload et fra katalogets detaljer.',
    importCatalogError: 'Importen blev afvist',
    registry: 'Registry',
    repository: 'Repository',
    cacheMissing: 'Clusterets OCI-cache er ikke konfigureret — pulls afvises, indtil du sætter en storage-pool.',
    setCache: 'Sæt cache',
    setCacheTitle: 'Konfigurer OCI-cachen',
    setCacheHint: 'DEFAULT-poolen på cluster-niveau, der huser de downloadede images blobs — et scope kan override med sin egen pool (Scope-siden). At ændre den er ikke hot og genstarter intet, og den flytter ikke blobs: de dukker lazy op igen ved næste start/brug.',
    cachePool: 'Storage-pool',
    changeCache: 'Skift cache',
    changeCacheTitle: 'Skift OCI-cachens pool',
    cacheCurrent: 'Clusterets OCI-cache (default): {name}',
    sectionOverview: 'Oversigt',
    sectionRepositories: 'Repositories',
    sectionExplore: 'Udforsk',
    exploreHint: 'Live fjernsøgning på registryet — Docker Hub fuldt (beskrivelse, downloads, stjerner), andre providere best-effort. Vælg et resultat for at læse den fulde beskrivelse og gennemse dets fjern-tags; fra et tag kan du tilføje referencen til et TVirt-repository.',
    exploreSearch: 'Søg',
    exploreUnsupported: 'Denne provider understøtter ikke søgning.',
    exploreNoResult: 'Intet matchende repository.',
    exploreNoTags: 'Intet matchende tag på dette repository.',
    exploreOfficial: 'Officielt',
    explorePulls: 'Downloads',
    exploreStars: 'Stjerner',
    exploreUpdated: 'Opdateret {when}',
    exploreLoadMore: 'Indlæs flere',
    exploreSelectHint: 'Vælg et resultat: den fulde beskrivelse og fjern-tags indlæses her.',
    exploreNoDescription: 'Ingen beskrivelse tilgængelig fra denne provider.',
    exploreTagsTitle: 'Fjern-tags',
    exploreTagFilter: 'Søg tag',
    exploreAddToRepo: 'Tilføj til repository',
    exploreAdded: '{path}:{tag} trackes nu — se sektionen Repositories.',
    addBranch: 'Tilføj branch',
    purgeRequiredTitle: "Slet '{name}' og dens images?",
    purgeRequiredBody: 'Ingen app bruger dette repository, men der findes stadig downloadede images: sletning fjerner også deres poster, og de cachede blobs går til garbage collection.',
    purgeConfirm: 'Slet også images',
    providerSelectHint: 'Vælg registry-typen: kortet fortæller preset og brug.',
    providerDesc: {
      dockerhub: 'Det offentlige Docker-registry: URL forudfyldt, fuld søgning med beskrivelser og tællere.',
      ghcr: 'GitHub Container Registry: URL forudfyldt; konti bruger et personal access token.',
      ecr: "Amazon Elastic Container Registry: endpoints pr. konto/region — URL'en skal angives.",
      quay: 'Red Hat Quay-registry: URL forudfyldt.',
      generic: "Self-hostet registry (Harbor, registry:2, …): https://-URL'en er obligatorisk."
    },
    layerCount: 'Layers',
    verifiedAt: 'Seneste verifikation',
    verifyOk: 'Udfald',
    verifyMessage: 'Verifikationsbesked',

    // Modellen #348/R39: imaget ER digesten — indholdet — og registry, repository og branch er de NAVNE, der når den.
    head: 'Head',
    heads: 'Heads pr. arkitektur',
    listDigest: 'Listens digest',
    neverResolved: 'Aldrig opløst',
    totalSize: 'Samlet størrelse',
    reflogTitle: 'Opløsningshistorik',
    usedBy: 'Brugt af',
    usageLockfile: 'lockfile',
    usageRunning: 'kører',
    evictable: 'kan fjernes',
    evict: 'Fjern fra cachen',
    evictHeadTitle: 'Fjern {digest}?',
    evictHeadBody: 'Det er den aktuelle opløsning for mindst én samler: at fjerne den er legitimt — det er kun cache, den eksterne branch leverer den stadig — men det må aldrig ske ved en fejl. Bloben er ÉN: fjernelsen tømmer alle samlere, der deler den.',
    evictConfirm: 'Fjern den alligevel',

    arch: 'Arkitektur',
    names: 'Navne',
    noNames: 'intet navn',
    views: 'Views',
    lastView: 'sidste view',
    evictLastViewTitle: 'Fjern den sidste reference til {digest}?',
    evictLastViewBody: 'Dette er det sidste view på indholdet: fjerner du det, ophører imaget med at findes på TVirt, og byte ({size}) frigives. Det er modellens docker image rm — ikke en sideeffekt, men selve handlingen.',
    branchesTabHint: 'De observerede branches i dette repository: for hver af dem dagens heads — én pr. arkitektur — kronologien over opdateringerne og hvor mange af de images, den har navngivet, der ligger i cachen. Opdateringen er repositoryets «git fetch»: den opløser alle dets branches på én gang.',
    noBranches: 'Ingen branch observeres i dette repository.',
    stopObserving: 'Stop med at observere branchen',
    pullBranch: 'Hent branchens head ind i cachen (refresh opløser, denne henter)',
    pullDigest: 'Hent dette digest ind i cachen',
    imageCount: 'Images',
    deleteBranchPurgeTitle: 'Efterlade images i {name} uden navn?',
    deleteBranchPurgeBody: 'Ingen app navngiver denne branch, men nogle images nås kun gennem den: sletter du den, bliver de liggende i cachen uden navn, oplistet blandt repositoryets images og mulige at rydde i hånden.',
    deleteBranchPurgeConfirm: 'Slet og efterlad images uden navn',
    imagesTabHint: 'Dette repositorys images — indholdet, altså digesterne — synlige også uden at vælge en branch. Et image er unikt pr. klynge: navnene, der når det, kan være flere.',
    noImages: 'Intet image fra dette repository er materialiseret i cachen.',
    deleteRepositoryTitle: 'Slet {name}?',
    deleteRepositoryBody: 'Repositoryet og dets branches forsvinder med deres kronologi. Images bliver i cachen: de mister kun dette navn. Et repository, som en app navngiver, kan ikke slettes.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Opdateret',
    neverRefreshed: 'Aldrig opdateret',
    sectionBranches: 'Branches',
    sectionImages: 'Images',
    repositoriesGovernedElsewhere: 'Her ses repositories kun: at registrere dem, opdatere dem, observere deres branches og rydde deres images sker i afsnittet OCI-images.',
    gotoImages: 'Gå til OCI-images'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Pods',
    containers: 'Containere',
    instances: 'Instanser',
    instancesTooltip: '{running} kører, {error} i fejl',
    placement: 'Placering',
    spread: 'spredning',
    ha: 'HA',
    templateRevision: 'revision',
    deleting: 'Sletter',
    empty: 'Ingen pods — opret en app (én container) eller en pod fra CLI (create-pod).',
    openInstances: 'Åbn instanserne',
    rollingRestart: 'Rullende genstart',
    scale: 'Skalér',
    scaleTitle: 'Skalér {name}',
    scaleHint: 'Antal instanser (0–64): op udfylder det laveste ledige ordinal, ned trækker det højeste tilbage og beholder dets persistente data.',
    scaleError: 'Skalering mislykkedes',
    replicas: 'Replikaer',
    deleteRunningError: '{name} kører — stop den først.',
    deleteInstancesIntro: 'Alle {count} instanser fjernes.',
    stateRunning: 'Kører',
    stateStopped: 'Stoppet',
    editor: {
      createTitle: 'Opret Pod',
      create: 'Opret Pod',
      editTitle: 'Rediger Pod',
      nameHint: 'DNS-1123, højst 58 tegn — instanserne hedder <navn>-<indeks>; uforanderligt efter oprettelse.',
      restartPolicy: 'Genstartspolitik',
      restartPolicyHint_always: 'Noden genstarter enhver afsluttet container med eksponentiel backoff (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Kun en container, der afslutter med andet end nul, genstartes; afslutning 0 hviler.',
      restartPolicyHint_never: 'En afsluttet container efterlades som den er — instansen ender som succeeded eller failed.',
      grace: 'Frist (s)',
      graceHint: 'SIGTERM → SIGKILL-grænsen for et stop.',
      hostname: 'Værtsnavn',
      hostnameHint: 'Tomt = instansens navn.',
      hostnameDefault: 'instansens navn',
      sharePid: 'Del PID-navnerum mellem containerne',
      containersIntro: 'Init-containere kører til ende, i rækkefølge, før containerne starter; containerne deler instansens netværk (én IP, localhost imellem dem).',
      initContainers: 'Init-containere',
      initAdd: 'Tilføj init-container',
      initHint: 'Hver skal afslutte med 0; en fejl sætter instansen i fejl, og noden prøver igen med backoff.',
      containerAdd: 'Tilføj container',
      atLeastOne: 'En Pod har brug for mindst én container.',
      duplicateNames: 'Containernavne skal være unikke i Podden (init-containere inklusive).',
      containerName: 'Containernavn',
      containerInvalid: 'Denne container er ufuldstændig: navn (DNS-1123), image, monteringer på deklarerede volumener, numeriske grænser og probe.',
      command: 'Kommando',
      commandHint: 'Tilsidesætter imagets entrypoint — ét argument pr. linje, aldrig en shell-streng.',
      args: 'Argumenter',
      argsHint: 'Ét pr. linje (imagets CMD hvis tomt).',
      mounts: 'Monteringer',
      mountAdd: 'Tilføj montering',
      mountNoVolumes: 'Deklarer først et volumen under fanen Lager.',
      readOnly: 'skrivebeskyttet',
      resources: 'Grænser',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (f.eks. 1.5)',
      memory: 'Hukommelse (MiB)',
      memoryHint: 'podman --memory',
      health: 'Liveness-probe',
      healthCmd: 'Probe-kommando',
      healthCmdHint: 'Kørt i containeren af noden ved hvert overvågningstik — ét argument pr. linje; afslutning 0 = sund.',
      healthTimeout: 'Timeout (s)',
      healthRetries: 'Forsøg',
      healthRetriesHint: 'Fortløbende fejl, før noden genstarter containeren.',
      ips: 'Statiske adresser',
      ipsHint: 'Én pr. instans, i ordenstalsrækkefølge — skalering ud over listen afvises.',
      instance: 'instans',
      volumesHint: 'Volumener er Poddens; monteringsstien er hver containers (fanen Containere).',
      spread: 'Spredning',
      spreadHint_preferred: 'Instanser på forskellige noder, når det er muligt.',
      spreadHint_required: 'Instanser på forskellige noder, ellers afviser skaleringen.',
      spreadHint_none: 'Kun beslutningstageren.',
      ha: 'Høj tilgængelighed (opt-in)',
      haHint: "Hver persistent del på delt storage; hvis noden dør, genskaber HA-decideren instanserne på et andet medlem (automatisk failover, som HA-VM'er).",
      yes: 'ja',
      no: 'nej'
    },
    detail: {
      container: 'Container',
      actions: 'Handlinger',
      ready: 'Klar',
      notReady: 'Ikke klar',
      restarts: 'Genstarter',
      lastRestartAt: 'Seneste genstart:',
      backoffUntil: 'Nyt forsøg kl.',
      stateAbsent: 'fraværende',
      stateRunning: 'kører',
      stateTerminated: 'afsluttet',
      stateWaiting: 'venter',
      init: 'init',
      noInstances: 'Ingen instanser (replikaer 0).',
      ha: 'HA',
      haHint: 'Automatisk failover: hvis noden dør, genskaber HA-decideren instansen på et andet medlem (hver persistent del på delt storage).',
      authority: 'Authority (node)',
      homeless: 'uden authority',
      homelessHint: 'En gendannelse fra checkpoint udelader authority (#380): ingen node betjener den, før du skalerer Podden (også til samme antal replikaer).',
      restartContainer: 'Genstart kun denne container (podden bliver oppe)',
      divergingHint: 'Denne instans\' ønskede tilstand afviger fra Poddens standard (PD-P19).',
      revisionLag: 'revision {applied} anvendt af {current}',
      updatedInstances: '{updated}/{desired} instanser på denne revision'
    }
  }
}
